// extracted by mini-css-extract-plugin
export default {"readOnly":"CustomDatePicker_readOnly__5y78+","fullWidth":"CustomDatePicker_fullWidth__D06yR"};